//!#system	

import axios from 'axios';
import qs from 'qs';
import series from 'to-series';
import store from '@/store/index.js';
import tools from '@/tools.js';

const formDataToBody = function(formData) {
	let stringBody = '', params = [];
	if (formData instanceof FormData) {
		for (var key of formData.entries()) {
			params.push(
				encodeURIComponent(key[0]) + '=' +
				encodeURIComponent(formDataValueParser(key[1]))
			);
		}
		stringBody = params.join('&');
	}
	return stringBody;
};

const formDataValueParser = function(val) {
	// do something here?
	return val;
};

export default {
	list(options, callback) {
		const { namespace, pluralName, filters } = options;
		let filterQs = qs.stringify(typeof filters !== 'object' ? {} : filters, { depth: 100 });
		let apiCallParams = {
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)),
			params: filterQs
		};
		if (filterQs.includes('%2Adeep%2A') || options.method === 'post') {
			// deep filters won't 'qs' well, because they go too deep!
			apiCallParams.method = 'post';
			delete apiCallParams.params;
			apiCallParams.body = filters;
		}
		this.call(apiCallParams, callback);
	},
	detail(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/detail/' + encodeURIComponent(id) + ( options.noActions ? '' : `?getActions=1` )
		}, callback);
	},
	deleteToken(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/delete-token/' + encodeURIComponent(id)
		}, callback);
	},
	delete(options, callback) {
		const { namespace, pluralName, id, deleteToken } = options;
		this.call({
			method: 'delete',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/delete/' + encodeURIComponent(id) + '/' + encodeURIComponent(deleteToken)
		}, callback);
	},
	blank(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes/blank'
		}, callback);
	},
	blanks(buckets, callback) {
		const blanks = {};
		series()
			.each(buckets, (bucket, cb) => {
				this.blank(tools.fromBucket(bucket), (err, response) => {
					if (err) return cb(err);
					blanks[bucket] = response;
					return cb();
				})
			})
			.end(err => {
				return callback(err, blanks);
			});
	},
	fields(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes/fields-info'
		}, callback);
	},
	history(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/history/' + encodeURIComponent(id)
		}, callback);
	},
	note(options, callback) {
		const { namespace, pluralName, id, note } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/note/' + encodeURIComponent(id),
			body: { note: note }
		}, callback);
	},
	image(options, callback) {
		const { url } = options;
		this.call({
			method: 'get',
			path: url
		}, callback);
	},
	create(options, callback) {
		const { namespace, pluralName } = options;
		const apiCallParams = {
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/create'
		};
		if (options.body) {
			apiCallParams.body = options.body;
		}
		if (options.formData) {
			apiCallParams.formData = options.formData;
		}
		this.call(apiCallParams, callback);
	},
	update(options, callback) {
		const { namespace, pluralName, id } = options;
		const apiCallParams = {
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/update/' + encodeURIComponent(id)
		};
		if (options.body) {
			apiCallParams.body = options.body;
		}
		if (options.formData) {
			apiCallParams.formData = options.formData;
		}
		this.call(apiCallParams, callback);
	},
	createRules(options, callback) {
		const { namespace, pluralName } = options;
		const apiCallParams = {
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/rule-create-runner'
		};
		if (options.body) {
			apiCallParams.body = options.body;
		}
		if (options.formData) {
			apiCallParams.formData = options.formData;
		}
		this.call(apiCallParams, callback);
	},
	pairs(options, callback) {
		const { namespace, pluralName, search } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/pairs' + '?search=' + encodeURIComponent(search || '')
		}, callback);
	},
	values(options, callback) {
		const { namespace, pluralName, fieldName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/values/' + encodeURIComponent(fieldName || '')
		}, callback);
	},
	possibleFilters(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/filters-for'
		}, callback);
	},
	possibleActions(options, callback) {
		const { namespace, pluralName, id, context } = options;
		let path = '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/actions/' + encodeURIComponent(id);
		if (!id) {
			path = '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/actions/';
		}
		let apiCallParams = {
			method: 'get',
			path: path,
			params: qs.stringify({ context: context })
		};
		this.call(apiCallParams, callback);
	},
	rulesTriggers(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/rules-triggers'
		}, callback);
	},
	rulesActions(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/rules-actions'
		}, callback);
	},
	rulesKeys(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/rules-keys'
		}, callback);
	},
	runRule(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + 
				'/rule-button/' +
				encodeURIComponent(options.name) + '/' +
				encodeURIComponent(options.id)
		}, callback);
	},
	params(options, callback) { // get params for actions
		const { namespace, pluralName, id, action } = options;
		let method = 'get';
		let path = '';
		if (id) {
			path = '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/params-for/' + encodeURIComponent(tools.camelCaseToDash(action)) + '/' + encodeURIComponent(id);
		} else {
			path = '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/params-for/' + encodeURIComponent(tools.camelCaseToDash(action));
		}
		return this.call({ method, path }, callback);
	},
	action(options, callback) {
		const { namespace, pluralName, id, payload, action } = options;
		let { method } = options;
		if (!method) method = 'get';
		let callParams = {
			method: method,
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/action/' + encodeURIComponent(tools.camelCaseToDash(action))
		};

		if (id) {
			callParams.path += '/' + encodeURIComponent(id);
		}
		if (payload) callParams.body = payload;
		this.call(callParams, callback);
	},
	isAdmin(callback) {
		const url = '/_sys/internals/uac/user-is-admin';
		this.call({
			method: 'get',
			path: url
		}, callback);
	},
	customHeaders(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/custom-headers'
		}, callback);
	},
	availableTags(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/available-tags'
		}, callback);
	},
	addAvailableTag(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/add-available-tag',
			formData: options.formData
		}, callback);
	},
	removeAvailableTag(options, callback) {
		const { namespace, pluralName, tag } = options;
		this.call({
			method: 'delete',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/remove-available-tag/' + encodeURIComponent(tag)
		}, callback);
	},
	getTags(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/tags/' + encodeURIComponent(id)
		}, callback);
	},
	tag(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/tag/' + encodeURIComponent(id),
			body: options.body
		}, callback);
	},
	untag(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'delete',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/tag/' + encodeURIComponent(id),
			body: options.body
		}, callback);
	},
	availableQueues(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes' + '/available-queues'
		}, callback);
	},
	addToQueues(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/action' + '/add-to-queue/' + encodeURIComponent(id),
			body: options.body
		}, callback);
	},
	removeFromQueues(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/action' + '/remove-from-queue/' + encodeURIComponent(id),
			body: options.body
		}, callback);
	},
	getLocks(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes' + '/get-locks/' + encodeURIComponent(id),
			body: options.body
		}, callback);
	},
	setLocks(options, callback) {
		const { namespace, pluralName, id, } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes' + '/set-locks/' + encodeURIComponent(id),
			body: options.body
		}, callback);
	},
	getSavedFilters(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'get',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes' + '/saved-filters'
		}, callback);
	},
	saveSavedFilter(options, callback) {
		const { namespace, pluralName } = options;
		this.call({
			method: 'post',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes' + '/save-filter',
			body: options.body
		}, callback);
	},
	deleteSavedFilter(options, callback) {
		const { namespace, pluralName, id } = options;
		this.call({
			method: 'delete',
			path: '/' + encodeURIComponent(tools.camelCaseToDash(namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(pluralName)) + '/utility-routes' + '/delete-filter/' + encodeURIComponent(id)
		}, callback);
	},
	getDashboardModules(options, callback) {
		const { dashboardKey } = options;
		this.call({
			method: 'get',
			path: '/system/dashboard-modules/?dashboard[dashboardKey]=' + encodeURIComponent(dashboardKey) + '&_orderBy_=' + encodeURIComponent('main."sortBy"') + '&_orderDirection_=ASC'
		}, callback);
	},
	call(options, callback) {
		let method, path, body, formData, params, axiosMethod, responseType, response = {},
			responseMeta = {},
			axiosOptions;
		const baseUrl = store.state.app.apiUrl;

		method = (options.method || 'GET').toUpperCase();
		body = options.body || null;
		formData = options.formData || null;
		path = options.path || '';
		params = options.params || null;
		responseType = options.responseType || 'json';
		axiosMethod = method.toLowerCase();

		let metaResponse = {
			validation: {
				messages: []
			},
			errCodes: []
		};

		axiosOptions = { // TODO: fix this - params are not right
			url: path,
			baseURL: baseUrl,
			method: axiosMethod,
			responseType: responseType,
			withCredentials: true
		};

		if (params && typeof params === 'string' && axiosOptions.method==='get') {
			if (axiosOptions.url.includes('?')) {
				axiosOptions.url += '&' + params;
			} else {
				axiosOptions.url += '?' + params;
			}
		} else if (params) {
			axiosOptions.data = params;
		}

		if (formData) {
			body = formDataToBody(formData);
		}

		if (body) {
			axiosOptions.data = body;
		}

		axios(axiosOptions)
			.then(responseData => {
				response = responseData.data;
				responseMeta = responseData.headers['x-app-meta'];
				if (responseMeta) {
					try {
						responseMeta = JSON.parse(responseMeta);
					} catch (e) {
						responseMeta = {};
					}
					metaResponse = Object.assign({}, metaResponse, responseMeta);
				}
				metaResponse.headers = responseData.headers;
				callback(null, response, metaResponse);
			})
			.catch(err => {
				console.log(err);
				console.log(err.response);
				if (err.response && err.response.status == 401) {
					store.dispatch('authentication/userInvalidate');
					// Reload the whole browser window, so that no Vue components
					// will have a cached user state
					// TODO: Page level loader
					setTimeout(function() {
						let currentRoute = window.location.pathname;
						if (window.location.search) currentRoute += window.location.search;
						if (currentRoute) {
							window.location.href = '/ui/sign-in?goto=' + encodeURIComponent(currentRoute);
						} else {
							window.location.reload(true); 
						}
					}, 500);
				}
				if (err.response && err.response.data) {
					response = err.response.data || {};
				} else if(err.data && Array.isArray(err.data.errors) && err.data.errors.length) {
					response = err.data;
				} else if(err.data && Array.isArray(err.data.messages)) {
					response = err.data;
				} else {
					response = {};
				}
				if (typeof response === 'object' && 'success' in response && 'errors' in response) {
					metaResponse.validation = response;
					metaResponse.validation.messages = [];
					metaResponse.validation.errors.forEach(item => {
						if (typeof item === 'object' && item.messages) {
							metaResponse.validation.messages = metaResponse.validation.messages.concat(item.messages);
						} else if (typeof item === 'object' && item.message) {
							metaResponse.validation.messages = metaResponse.validation.messages.concat(item.message);
						}
						metaResponse.errCodes.push(item.code);
					});
					err.message = metaResponse.validation.messages.join(' ');
				} else {
					try {
						response.success = false;
					} catch(err) {
						response = {
							success: false
						};
					}
					metaResponse.validation.messages.push('Something is wrong.. please try again in a little bit.');
				}
				callback(err, response, metaResponse);
			});

		/*
			https://www.npmjs.com/package/@tozd/vue-snackbar-queue

		 */
	}
}